// extracted by mini-css-extract-plugin
export default {"arrow":"CollapseComponent_arrow__PIol6","active":"CollapseComponent_active__EZ5x4"};